<template>
  <div class="text-h3 text-center font-weight-bold">404 page not found</div>
</template>

<script> /* eslint-disable */
import {inject} from 'vue'

export default {
  name: 'NotFound',
  setup (props, context) {
    const { setStorage } = inject('storage')

    setStorage('showBack', true)
    setStorage('overlay', false)
  }
}
</script>
